module.exports = __webpack_public_path__ + "img/Kuchen.3e9c834d.jpg";